// 图表
<template>
  <div class="statistics">
    <van-nav-bar fixed placeholder>
      <template #title>
        <div class="flex justify-center align-end" style="font-size: 16px">
          <van-icon
            style="margin-right: 8px"
            size="24"
            :name="require('@/assets/images/login-page/logo.png')"
          />
          {{ $t("menu.home") }}
        </div>
      </template>
    </van-nav-bar>
    <section>
      <div class="card flex align-center">
        <div class="flex-1">
          <van-circle
            :value="ringPercentage"
            :rate="100"
            size="120px"
            :layer-color="ringLayerColor"
            :color="ringColor"
            :stroke-width="80"
          >
            <template>
              <div
                class="flex-column justify-center align-center"
                style="height: 100%"
              >
                <div class="title">{{ "Today" }}</div>
                <div class="desc">
                  <span class="text2">{{ todayInhalationTimes || 0 }}</span>
                  puffs
                </div>
              </div>
            </template>
          </van-circle>
        </div>
        <div class="flex-1 flex-column align-center">
          <div class="title">Daily puff</div>
          <div class="desc">
            <span class="flex align-center text3">
              <van-icon
                :name="require('@/assets/images/icon/edit.png')"
              ></van-icon>
              <van-field
                type="number"
                v-model="ringMaxScale"
                format-trigger="onBlur"
                input-align="center"
                @input="dailyChange"
              />
            </span>
            puffs
          </div>
          <!-- <div class="desc"><span class="text2">{{ detail.avg7DayInhalationTimes || 0 }}</span> puffs</div> -->
        </div>
      </div>
      <div class="row flex justify-between">
        <div class="left flex-column justify-center align-center">
          <div class="title">{{ "Data Record" }}</div>
          <div class="desc">
            <span class="text fs-36">{{ detail.usageDays || 0 }}</span> days
          </div>
        </div>
        <div class="right flex-column justify-center align-center">
          <div class="title">{{ "Average Puffs" }}</div>
          <div class="desc">
            <span class="text fs-36">{{ detail.avg7DayInhalationTimes }}</span>
            puffs/day
          </div>
        </div>
      </div>
      <div class="card">
        <div class="title">{{ "Puff Record" }}</div>
        <van-icon
          class="prev"
          size="18"
          name="arrow-left"
          @click="prev"
        ></van-icon>
        <van-icon class="next" size="18" name="arrow" @click="next"></van-icon>
        <div class="week flex" ref="smokingVos">
          <div
            class="week-item flex-column justify-end align-center"
            ref="vos"
            v-for="(item, index) in smokingVos"
            :key="index"
          >
            <div
              class="
                progress-container
                flex-column-reverse
                justify-start
                align-center
              "
            >
              <div
                :class="
                  item.inhalationTimes === max && max > 0
                    ? 'progress fill'
                    : 'progress'
                "
                :style="`height: ${(item.inhalationTimes / max) * 100 || 0}%`"
              ></div>
              <span class="num">{{ item.inhalationTimes }}</span>
            </div>
            <span class="date">{{ item.belongsToDate }}</span>
          </div>
        </div>
        <div
          class="flex justify-around"
          style="margin: 10px auto 0; width: 50%"
        >
          <van-button
            round
            :plain="pagination.type !== 1"
            size="small"
            style="width: 65px"
            :color="
              pagination.type === 1
                ? 'linear-gradient(30deg, #3EE191, #24DEDD)'
                : '#EEEEEE'
            "
            type="info"
            @click="changeType(1)"
          >
            day
          </van-button>
          <van-button
            round
            :plain="pagination.type !== 2"
            size="small"
            style="width: 65px"
            :color="
              pagination.type === 2
                ? 'linear-gradient(30deg, #3EE191, #24DEDD)'
                : '#EEEEEE'
            "
            type="info"
            @click="changeType(2)"
          >
            week
          </van-button>
        </div>
      </div>
      <div class="card">
        <div class="title">{{ "Flavor Statistics" }}</div>
        <div class="chart">
          <div
            v-if="echartData.length"
            id="pie"
            style="width: 100%; height: 100%"
          ></div>
          <div
            v-else
            class="flex justify-center align-center"
            style="height: 100%"
          >
            No data
          </div>
        </div>
        <div class="title total">
          Total:
          <span class="text">{{ detail.usedCartridgesCount || 0 }}</span> pods
        </div>
      </div>
      <div class="card" @click="$router.push('history')">
        <div class="title flex justify-between total">
          Device history
          <van-icon name="arrow"></van-icon>
        </div>
        <van-divider />
        <div class="title total">
          Total: <span class="text">{{ detail.usedDevicesCount || 0 }}</span
          >devices
        </div>
      </div>
      <van-button
        style="width: 50%; margin: 0 auto"
        block
        round
        size="large"
        color="linear-gradient(30deg, #3EE191, #24DEDD)"
        type="info"
        :icon="require('@/assets/images/icon/picture.png')"
        @click="downloadPoster"
      >
        {{ "Download" }}
      </van-button>
    </section>
    <tab-bar />
  </div>
</template>

<script>
import TabBar from "@/components/tab-bar";
import {
  personSmokingStats,
  personSmokingStatsDetail,
  personTodaySmokingStats,
  statsPoster,
  getCurrentAllList,
  setStickEuipment,
} from "@/api";
export default {
  beforeDestroy() {
    if (this.$store.state.app.idOfConnectedDevice !== -1) {
      window.webkit.messageHandlers.whenStatisticsPageDestroyed.postMessage(
        this.detail.equipmentName
      ); // 通知宿主将退出统计页
      console.log('通知宿主将退出统计页');
    }
  },
  name: "Statistics",
  components: {
    TabBar,
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      pagination: {
        type: 1,
        page: 1,
        size: 30,
      },
      list: [],
      currentRate: 90,
      detail: {},
      smokingVos: [
        // { inhalationTimes: 11, belongsToDate: '6/11' },
        // { inhalationTimes: 6, belongsToDate: '6/12' },
        // { inhalationTimes: 24, belongsToDate: '6/13' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
        // { inhalationTimes: 2, belongsToDate: '6/14' },
      ],
      echartData: [],
      key_RingRate: "Statistics_RingMaxScale", // 圆环的最大刻度 缓存键
      ringLayerColor: "#E5E5E5", // 圆环背景色
      ringColor: "#3EE191", // 圆环颜色
      ringMaxScale: 200, // 圆环的最大刻度
      ringPercentage: 0, // 圆环的百分比
      todayInhalationTimes: null, // 进入吸烟口数
    };
  },
  watch: {
    idOfConnectedDevice: function (val, oldVal) {
      if (val === -1) {
        // 设备已断开
        this.$dialog.confirm({
          title: 'Tips',
          message: 'Do you want to reconnect?',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel'
        }).then(res => {
          this.getUsingEuipments_WithHide((euipmentArr) => {
            if (!euipmentArr.length) return;
            this.$toast.loading({
              duration: 0,
              forbidClick: true,
              className: "tips_toast",
              position: "middle",
              type: "html",
              message: `<div class="van-loading van-loading--circular van-toast__loading"><span class="van-loading__spinner van-loading__spinner--circular"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div><p>Connecting...</p>Tips:Please vape your device to wake Bluetooth.`,
            });
            /** 通知宿主连接列表中任意一个设备 */
            window.webkit.messageHandlers.tryConnecting2AnyDeviceInTheList.postMessage(
              JSON.stringify(euipmentArr)
            );
          })
          // TODO 询问"是否连接"弹窗
          // this.getUsingEuipments_WithHide((euipmentArr) => {
          //   if (!euipmentArr.length) return;
          //   this.$toast.loading({
          //     duration: 0,
          //     forbidClick: true,
          //     className: "tips_toast",
          //     position: "middle",
          //     type: "html",
          //     message: `<div class="van-loading van-loading--circular van-toast__loading"><span class="van-loading__spinner van-loading__spinner--circular"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div><p>Connecting...</p>Tips:Please vape your device to wake Bluetooth.`,
          //   });
          //   /** 通知宿主连接列表中任意一个设备 */
          //   window.webkit.messageHandlers.tryConnecting2AnyDeviceInTheList.postMessage(
          //     JSON.stringify(euipmentArr)
          //   );
          // }, null);
        })
      }
    }
  },
  computed: {
    idOfConnectedDevice() {
      return this.$store.state.app.idOfConnectedDevice;
    },
    max() {
      return Math.max.apply(
        Math,
        this.smokingVos.map((item) => {
          return item.inhalationTimes;
        })
      );
    },
  },
  created() {
    try {
      const temp_Str = localStorage.getItem(this.key_RingRate);
      if (temp_Str && !isNaN(parseInt(temp_Str)))
        this.ringMaxScale = parseInt(temp_Str);
    } catch (e) {}

    this.init();
    personSmokingStatsDetail().then((res) => {
      this.detail = res.data;
      this.todayInhalationTimes = parseInt(this.detail.todayInhalationTimes);
      this.updateRing(this.detail.todayInhalationTimes, this.ringMaxScale);
      this.echartData = this.objArrtransArr(
        this.detail.customersTasteVos,
        "tasteName",
        "percentage"
      );
      console.log(this.detail.customersTasteVos, this.echartData);
      this.$nextTick(() => {
        this.initChart();
      });
    });
    // personTodaySmokingStats().then(res => {

    // })
  },
  methods: {
    // 初始化列表
    async init() {
      await personSmokingStats({
        pageNum: this.pagination.page,
        pageSize: this.pagination.size,
        type: this.pagination.type,
      })
        .then((res) => {
          this.smokingVos = res.data;
          setTimeout(() => {
            const item = this.$refs.vos.length
              ? this.$refs.vos[0].offsetWidth
              : 0;
            const num = this.$refs.vos.length + 50;
            if (this.$refs.vos.length) {
              const margin =
                (this.$refs.smokingVos.offsetWidth -
                  this.$refs.vos[0].offsetWidth * 7) /
                7;
              this.$refs.vos.map((item) => {
                item.style = `margin: 0 ${margin / 2}px`;
              });
            }
            this.$refs.smokingVos.scrollLeft = item * num;
            console.log(
              (this.$refs.smokingVos.offsetWidth -
                this.$refs.vos[0].offsetWidth * 7) /
                7
            );
          }, 200);
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    initChart() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById("pie"));
      const colorList = [
        // new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: '#2AFF89'
        //   },
        //   {
        //     offset: 1,
        //     color: '#09CE78'
        //   }
        // ]),
        // new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: '#F06B00'
        //   },
        //   {
        //     offset: 1,
        //     color: '#FF932D'
        //   }
        // ]),
        // new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: '#3525AF'
        //   },
        //   {
        //     offset: 1,
        //     color: '#693EBE'
        //   }
        // ]),
        // new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: '#04C7E0'
        //   },
        //   {
        //     offset: 1,
        //     color: '#4CEEFF'
        //   }
        // ]),
        // new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: '#ED204E'
        //   },
        //   {
        //     offset: 1,
        //     color: '#FF2053'
        //   }
        // ])
        "#74D496",
        "#43B5E3",
        "#ED9D25",
        "#7C5FB5",
        "#E41887",
      ];

      // 指定图表的配置项和数据
      const option = {
        legend: {
          orient: "vertical",
          top: "center",
          right: 0,
          selectedMode: false,
          itemWidth: 10,
          itemHeight: 10,
          formatter: function (params) {
            let tip1 = "";
            let tip = "";
            let le = params.length; //图例文本的长度
            if (le > 20) {
              //几个字换行大于几就可以了
              let l = Math.ceil(le / 20); //有些不能整除，会有余数，向上取整
              for (let i = 1; i <= l; i++) {
                //循环
                if (i < l) {
                  //最后一段字符不能有\n
                  tip1 += params.slice(i * 20 - 20, i * 20) + "\n"; //字符串拼接
                } else if (i === l) {
                  //最后一段字符不一定够9个
                  tip = tip1 + params.slice((l - 1) * 20, le); //最后的拼接在最后
                }
              }
              return tip;
            } else {
              tip = params; //前面定义了tip为空，这里要重新赋值，不然会替换为空
              return tip;
            }
          },
        },
        color: colorList,
        series: [
          {
            name: "",
            type: "pie",
            silent: true,
            center: [80, "50%"],
            radius: ["44%", "90%"],
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: "inner",
              formatter: "{c}%",
              fontSize: 9,
              edgeDistance: "50%",
              distanceToLabelLine: 10,
              alignTo: "edge",
              backgroundColor: "#234",
              textBorderColor: "#fff",
              textBorderWidth: 0.5,
            },
            select: {
              disabled: false,
            },
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            data: this.echartData,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 底部加载
    onLoad() {
      this.loading = true;
      if (this.list.length >= this.pagination.total) {
        this.finished = true;
      } else {
        setTimeout(() => {
          this.init();
        }, 1000);
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;

      if (this.refreshing) {
        this.pagination.page = 1;
        this.list = [];
        this.refreshing = false;
        this.loading = false;
      }
      this.init();
    },
    // 上一页
    prev() {
      const dis = this.$refs.smokingVos.offsetWidth;
      const currentLeft = this.$refs.smokingVos.scrollLeft;
      this.$refs.smokingVos.scrollLeft = currentLeft - dis;
    },
    // 下一页
    next() {
      const dis = this.$refs.smokingVos.offsetWidth;
      const currentLeft = this.$refs.smokingVos.scrollLeft;
      this.$refs.smokingVos.scrollLeft = currentLeft + dis;
    },
    changeType(val) {
      if (val !== this.pagination.type) {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
        });
        this.pagination.type = val;
        this.init();
      }
    },
    downloadPoster({}) {
      statsPoster().then((res) => {
        if (res.code === 200) {
          window.webkit.messageHandlers.try2DownloadStatsPoster.postMessage(
            res.data
          ); // 将图片地址推送给宿主
        } else {
          this.$toast(res.msg);
        }
      });
    },
    objArrtransArr(oldData, oldName, oldVal) {
      const newArr = [];
      oldData.forEach((item) => {
        let obj = {};
        obj.name = item[oldName];
        obj.value = (item[oldVal] * 100).toFixed(1);
        newArr.push(obj);
      });
      return newArr;
    },
    /** 当收到设备的累计吸入次数时 */
    whenCusumInhalationTimesOfDeviceReceived(res) {
      this.todayInhalationTimes =
        this.todayInhalationTimes < parseInt(res)
          ? parseInt(res)
          : (isNaN(parseInt(this.todayInhalationTimes))
              ? 0
              : parseInt(this.todayInhalationTimes)) + 1;
      this.updateRing(this.todayInhalationTimes, this.ringMaxScale);
    },
    /** 更新圆环 */
    updateRing(numerator, denominator) {
      const Numerator = isNaN(parseFloat(numerator))
        ? 0
        : parseFloat(numerator);
      const Denominator = isNaN(parseFloat(denominator))
        ? 0
        : parseFloat(denominator);
      const Percentage =
        Denominator === 0.0 ? 0.0 : parseFloat(Numerator / Denominator);
      const Floor = Math.floor(Percentage);
      switch (Floor) {
        case 0:
          this.ringLayerColor = "#E5E5E5"; // 灰
          this.ringColor = "#3EE191"; // 绿
          break;

        case 1:
          this.ringLayerColor = "#3EE191"; // 绿
          this.ringColor = "#EEDF38"; // 黄
          break;

        case 2:
          this.ringLayerColor = "#EEDF38"; // 黄
          this.ringColor = "#FF4352"; // 暗粉
          break;

        case 3:
          this.ringLayerColor = "#FF4352"; // 暗粉
          this.ringColor = "#B7202B"; // 红
          break;

        default:
          this.ringLayerColor = "#B7202B"; // 红
          this.ringColor = "#B7202B"; // 红
      }
      this.ringPercentage = parseFloat(Percentage - Floor) * 100;
    },
    dailyChange(newValue) {
      localStorage.setItem(this.key_RingRate, newValue);
      this.updateRing(this.todayInhalationTimes, this.ringMaxScale);
    },
    /** 获取 当前用户使用中(包括隐藏)的设备 列表 */
    getUsingEuipments_WithHide(
      callbackWhenSuccess, // 成功时回调
      callbackWhenFail // 失败时回调
    ) {
      getCurrentAllList({
        pageNum: 1,
        pageSize: 50000,
      }).then((res) => {
        if (res.code === 200) {
          if (callbackWhenSuccess) callbackWhenSuccess(res.data);
        } else {
          this.$toast.clear();
          this.$toast("Network anomaly, Operation interrupted.");
          if (callbackWhenFail) callbackWhenFail(res);
        }
      });
    },
    /** 置顶设备 */
    setTop(item) {
      setStickEuipment({
        id: item.id,
        imie: this.$store.state.app.imie,
      }).then((res) => {
        this.$toast.clear();
        this.$toast("connect successfully");
      });
    },
    /** 连接列表中任意一个设备 成功后的回调函数 */
    connecting2AnyDeviceInTheList_Succeed_Callback(equipmentCode) {
        this.getUsingEuipments_WithHide((euipmentArr) => {
          const id = euipmentArr.find(x => x.hasOwnProperty('equipmentId') && x.equipmentId == equipmentCode);
          if (!id) return;
          this.$store.commit("setIdOfConnectedDevice", id);
          this.setTop({ id: id });
        }, null);
    },
    /** 连接列表中任意一个设备 失败后的回调函数 */
    connecting2AnyDeviceInTheList_Failed_Callback(meaningless) {
      this.$toast.clear();
      this.$toast("operate fail");
    },
  },
  mounted() {
    window.pushCusumInhalationTimesOfDevice = this.whenCusumInhalationTimesOfDeviceReceived; // 当收到设备的累计吸入次数时
    window.connecting2AnyDeviceInTheList_Succeed = this.connecting2AnyDeviceInTheList_Succeed_Callback; // 注册 连接列表中任意一个设备 成功后的回调函数
    window.connecting2AnyDeviceInTheList_Failed = this.connecting2AnyDeviceInTheList_Failed_Callback; // 注册 连接列表中任意一个设备 失败后的回调函数
  },
}
</script>

<style lang="less">
.statistics {
  padding: 30px;
  .title {
    font-size: 25px;
    color: #000;
    padding: 0 0 20px;
    font-weight: normal;
  }
  .desc_i {
    font-size: 25px;
    font-style: italic;
    font-weight: bold;
    .text {
      margin-left: 20px;
    }
  }
  .desc {
    font-size: 20px;
    display: flex;
    align-items: center;
    .text3 {
      display: inline-flex;
      font-weight: bold;
      margin: 0 12px;
      padding: 0px 16px;
      border: 2px solid #b6b6b6;
      width: 88px;
      border-radius: 15px;
      .van-cell {
        padding: 0;
        display: inline-block;
      }
      .van-field__control {
        color: #5de7bf;
      }
    }
  }
  .text {
    margin-right: 8px;
    font-size: 24px;
    font-weight: bold;
    color: #5de7bf;
    // background-image: -webkit-gradient(linear, left 0, right 0, from(#3EE191), to(#24DEDD));
    // -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
    // -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
  }
  .text2 {
    margin-right: 8px;
    font-size: 30px;
    font-weight: bold;
    color: #5de7bf;
  }
  .fs-36 {
    font-size: 36px;
  }
  .row {
    margin-bottom: 20px;
    .title {
      font-size: 20px;
    }
    .left,
    .right {
      width: 48%;
      height: 190px;
      background: #fff;
      border-radius: 15px;
      box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.2);
    }
  }
  .card {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-radius: 15px;
    margin-bottom: 20px;
    padding: 32px 30px;
    box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.2);
    .total {
      padding: 0;
    }
    .card-item {
      height: 100%;
      .left {
        width: 40%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 55%;
        .brief {
          font-size: 26px;
          color: #333;
          height: 105px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box; //作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
          -webkit-line-clamp: 3; //显示的行
        }
        .time {
          color: #999;
          font-size: 22px;
        }
      }
    }
  }
  .next,
  .prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .prev {
    left: 20px;
  }
  .next {
    right: 20px;
  }
  .week {
    margin: 0 auto;
    width: 100%;
    overflow-x: scroll;
    min-height: 356px;
    .week-item {
      // margin: 0 12px;
      .num {
        font-size: 18px;
        margin-bottom: 8px;
      }
      .progress-container {
        height: 240px;
        width: 40px;
        .progress {
          width: 100%;
          background: #e5e5e5;
          border-radius: 10px;
          border-bottom: 1px solid #e5e5e5;
        }
        .fill {
          background: linear-gradient(30deg, #3ee191, #24dedd);
        }
        .fill + span {
          color: #3be199;
        }
      }
      .date {
        margin-top: 8px;
        font-size: 12px;
      }
    }
  }
  .chart {
    width: 100%;
    height: 300px;
    // background: #f7f7f7;
    border-radius: 16px;
  }
}
</style>
